import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from './translation/en.json';

const resources = { en: { translation } } as const;

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  resources,
  returnNull: false,
});

export default i18n;
